// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoticeCardDescription_wrapper__oW39Q"};